import React from 'react';
import styled from 'styled-components';
import config from 'config';
import history from '../../history';

import Table from 'components/table';
import {LinkSmall} from 'components/buttons';

const Thead = styled.thead`
  tr > th {
    color: #000 !important;
  }
`;

const NewsList = ({ news }) => {
  const handleLinkClick = e => e.stopPropagation()

  const renderDatePublished = date => {
    return date
      ? new Date(date).toLocaleString('uk-UA', config.options)
      : 'Відсутня'
  }

  return <Table hover maxNewsWidth>
    <Thead>
    <tr>
      <th>Новина</th>
      <th>Короткий опис новини</th>
      <th>Поточний стан</th>
      <th>Дата публікації</th>
    </tr>
    </Thead>
    <tbody>
      {news.map((item, i) => (
        <tr key={i} onClick={() => history.push(`/admin/news/detail/${item.get('id')}`)}>
          <td><span>Новина:</span>{item.get('title')}</td>
          <td><span>Короткий опис новини:</span>{item.get('brief_description')}</td>
          {item.get('current_status') === 'public' ?  (
             <td><span>Поточний стан:</span>Опублікована</td>
          ): (
            <td><span>Поточний стан:</span>Чернетка</td>
          )}
          <td> <span>Дата публікації:</span>{renderDatePublished(item.get('date_published'))}</td>
          <td><LinkSmall to={`/admin/news/detail/${item.get('id')}`} onClick={handleLinkClick}>Детальніше</LinkSmall></td>
        </tr>
      ))}
    </tbody>
  </Table>
}

export default NewsList;



// WEBPACK FOOTER //
// ./src/admin/news/news-list.js